import React, { Component } from 'react';
import { HashRouter,Switch, Route, Redirect } from 'react-router-dom';
import DefaultLayout from "./layout/DefaultLayout";
/*import Header from './layout/Header';
import Menu from './layout/Menu';
import Footer from './layout/Footer';*/

import Login from './page/login/Login';


const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route {...rest} render={props => (
        sessionStorage.getItem('ses_mogi') ? (
            <Component {...props} />
        ) : (
                <Redirect to={{
                    pathname: '/login',
                    state: { from: props.location }
                }} />
        
      )
    )} />
);

class App extends Component {
  render() {
    return (
      <HashRouter>
        <Switch>
          <Route path="/login" name="Login Page" component={Login} />
          <PrivateRoute path="/" name="Home" component={DefaultLayout} />
        </Switch>
      </HashRouter>
    );
  }
}

export default App;